import { schema } from "normalizr";

const imageSchema = new schema.Entity("images", { idAttribute: "id" });

export default imageSchema;



// WEBPACK FOOTER //
// ./src/schemas/image.js